export const CATALOG_COURSES_CATEGORIES = {
  physics: 'физико-математический',
  language: 'лингвистический',
  humanitarian: 'гуманитарный',
  socialEconomy: 'соц. экономический',
};

export const CATALOG_COURSES_CARDS = [
  {
    id: 1,
    title: 'Roblox',
    description: 'программирование <br>для детей',
    chips: ['5-11 класс', 'бесплатно'],
    image: '/v2/catalog-courses/cards/card-image-1.webp',
    // eslint-disable-next-line max-len,vue/max-len
    content: 'научитесь разрабатывать собственные игры и получите опыт в Roblox Studio с использованием языка программирования Lua',
    price: {
      free: true,
      description: 'доступ к курсу на 30 дней',
    },
    cardLink: '/catalog/courses/roblox',
    filter: CATALOG_COURSES_CATEGORIES.physics,
  },
  {
    id: 2,
    title: 'Construct 3',
    description: 'программирование <br>для детей',
    chips: ['5-11 класс', 'бесплатно'],
    image: '/v2/catalog-courses/cards/card-image-2.webp',
    // eslint-disable-next-line max-len,vue/max-len
    content: 'разрабатывайте собственные игры с помощью Construct 3',
    price: {
      free: true,
      description: 'доступ к курсу на 30 дней',
    },
    cardLink: '/catalog/courses/construct-3',
    filter: CATALOG_COURSES_CATEGORIES.physics,
  },
  {
    id: 3,
    title: 'веб-разработка: основы',
    description: 'программирование <br>для детей',
    chips: ['5-11 класс', 'бесплатно'],
    image: '/v2/catalog-courses/cards/card-image-3.webp',
    // eslint-disable-next-line max-len,vue/max-len
    content: 'научитесь создавать веб-приложения, используя основные принципы HTML, CSS и базовые функции JavaScript',
    price: {
      free: true,
      description: 'доступ к курсу на 30 дней',
    },
    cardLink: '/catalog/courses/web-programmirovanie',
    filter: CATALOG_COURSES_CATEGORIES.physics,
  },
  {
    id: 4,
    title: 'Python',
    description: 'программирование <br>для детей',
    chips: ['5-11 класс', 'бесплатно'],
    image: '/v2/catalog-courses/cards/card-image-4.webp',
    // eslint-disable-next-line max-len,vue/max-len
    content: 'научитесь создавать веб-приложения и ботов для ВКонтакте с использованием Python, HTML, CSS и JavaScript',
    price: {
      free: true,
      description: 'доступ к курсу на 30 дней',
    },
    cardLink: '/catalog/courses/python',
    filter: CATALOG_COURSES_CATEGORIES.physics,
  },
  {
    id: 5,
    title: 'пространство <br>и плоскость',
    description: 'геометрия для детей',
    chips: ['5-11 класс', 'бесплатно'],
    image: '/v2/catalog-courses/cards/card-image-5.webp',
    // eslint-disable-next-line max-len,vue/max-len
    content: 'на курсе ребенок сможет развить геометрическое воображение, которое станет фундаментом для изучения геометрии в будущем',
    price: {
      free: true,
      description: 'доступ к курсу на 30 дней',
    },
    cardLink: '/catalog/courses/uglublennaya-geometriya',
    filter: CATALOG_COURSES_CATEGORIES.physics,
  },
  {
    id: 6,
    title: 'ментальная <br>арифметика',
    description: '',
    chips: ['5-11 класс', 'бесплатно'],
    image: '/v2/catalog-courses/cards/card-image-6.webp',
    // eslint-disable-next-line max-len,vue/max-len
    content: 'с помощью счетов вы развиваете не только вычислительные способности, но и креативность, внимание, интеллект и способность быстро усваивать новые знания',
    price: {
      free: true,
      description: 'доступ к курсу на 30 дней',
    },
    cardLink: '/catalog/courses/mentalnaya-arifmetika',
    filter: CATALOG_COURSES_CATEGORIES.physics,
  },
  {
    id: 7,
    title: 'углубленное изучение английского',
    description: '',
    chips: ['5-11 класс', 'бесплатно'],
    image: '/v2/catalog-courses/cards/card-image-7.webp',
    // eslint-disable-next-line max-len,vue/max-len
    content: 'этот курс фокусируется на развитии основных речевых навыков, с упором на практическое применение в реальных ситуациях',
    price: {
      free: true,
      description: 'доступ к курсу на 30 дней',
    },
    cardLink: '/catalog/courses/uglublennyj-anglijskij',
    filter: CATALOG_COURSES_CATEGORIES.language,
  },
  {
    id: 8,
    title: 'i can! навык владения английским',
    description: '',
    chips: ['5-11 класс', 'бесплатно'],
    image: '/v2/catalog-courses/cards/card-image-8.webp',
    // eslint-disable-next-line max-len,vue/max-len
    content: 'этот курс поможет школьникам подготовиться к подтверждению уровня А2 владения языком, развивая навыки чтения, письма, говорения и аудирования на актуальных и интересных темах',
    price: {
      free: true,
      description: 'доступ к курсу на 30 дней',
    },
    cardLink: '/catalog/courses/anglijskij-dlya-detej',
    filter: CATALOG_COURSES_CATEGORIES.language,
  },
  {
    id: 9,
    title: 'курс «основы рисунка»',
    description: '',
    chips: ['5-11 класс', 'бесплатно'],
    image: '/v2/catalog-courses/cards/card-image-9.webp',
    // eslint-disable-next-line max-len,vue/max-len
    content: 'поможем развить художественные навыки, аналитические способности и пространственное мышление через изучение изобразительного искусства',
    price: {
      free: true,
      description: 'доступ к курсу на 30 дней',
    },
    cardLink: '/catalog/courses/osnovy-risunka',
    filter: CATALOG_COURSES_CATEGORIES.humanitarian,
  },
  {
    id: 10,
    title: 'основы дизайна презентаций',
    description: '',
    chips: ['5-11 класс', 'бесплатно'],
    image: '/v2/catalog-courses/cards/card-image-10.webp',
    // eslint-disable-next-line max-len,vue/max-len
    content: 'этот курс познакомит школьников с профессией графического дизайнера, расскажет об инструментах и фишках, которые использует дизайнер в своей работе',
    price: {
      free: true,
      description: 'доступ к курсу на 30 дней',
    },
    cardLink: '/catalog/courses/dizajn-prezentacij',
    filter: CATALOG_COURSES_CATEGORIES.socialEconomy,
  },
  {
    id: 11,
    title: '«между строк»',
    description: 'литературный кружок <br>для детей',
    chips: ['5-11 класс', 'бесплатно'],
    image: '/v2/catalog-courses/cards/card-image-11.webp',
    // eslint-disable-next-line max-len,vue/max-len
    content: 'погружаем в мир литературы: открываем красоту русской и зарубежной классики, расширяем кругозор чтением, учим читать качественно и глубоко, развиваем художественное восприятие',
    price: {
      free: true,
      description: 'доступ к курсу на 30 дней',
    },
    cardLink: '/catalog/courses/literaturnyj-kruzhok',
    filter: CATALOG_COURSES_CATEGORIES.humanitarian,
  },
  {
    id: 12,
    title: '«мастер слова»',
    description: 'курс развитие речи <br>для детей',
    chips: ['5-11 класс', 'бесплатно'],
    image: '/v2/catalog-courses/cards/card-image-12.webp',
    // eslint-disable-next-line max-len,vue/max-len
    content: 'обучаем детей говорить лучше: расширяем словарный запас, развиваем выразительности речи и навыков общения',
    price: {
      free: true,
      description: 'доступ к курсу на 30 дней',
    },
    cardLink: '/catalog/courses/kurs-razvitie-rechi',
    filter: CATALOG_COURSES_CATEGORIES.humanitarian,
  },
  {
    id: 13,
    title: 'финансовая грамотность',
    description: 'курс по основам для детей',
    chips: ['5-11 класс', 'бесплатно'],
    image: '/v2/catalog-courses/cards/card-image-13.webp',
    // eslint-disable-next-line max-len,vue/max-len
    content: 'сформируем финансовую грамотность у детей через освоение базовых понятий, развитие экономического мышления, а также применение знаний для решения финансовых вопросов в жизни',
    price: {
      free: true,
      description: 'доступ к курсу на 30 дней',
    },
    cardLink: '/catalog/courses/fin-gramotnost-base',
    filter: CATALOG_COURSES_CATEGORIES.socialEconomy,
  },
  {
    id: 14,
    title: 'финансовая грамотность',
    description: 'расширенный курс <br>для детей',
    chips: ['5-11 класс', 'бесплатно'],
    image: '/v2/catalog-courses/cards/card-image-14.webp',
    // eslint-disable-next-line max-len,vue/max-len
    content: 'этот курс научит детей ценить деньги и труд, а также правильно управлять своими финансами',
    price: {
      free: true,
      description: 'доступ к курсу на 30 дней',
    },
    cardLink: '/catalog/courses/fin-gramotnost-pro',
    filter: CATALOG_COURSES_CATEGORIES.socialEconomy,
  },
  {
    id: 15,
    title: 'экономика <br>вокруг нас',
    description: '',
    chips: ['5-11 класс', 'бесплатно'],
    image: '/v2/catalog-courses/cards/card-image-15.webp',
    // eslint-disable-next-line max-len,vue/max-len
    content: 'сформируете полное представление о мире экономики и научитесь исследовать экономические процессы. Узнаете, как развивается экономика России в глобальном контексте',
    price: {
      free: true,
      description: 'доступ к курсу на 30 дней',
    },
    cardLink: '/catalog/courses/ekonomika-dlya-detej',
    filter: CATALOG_COURSES_CATEGORIES.socialEconomy,
  },
];
